/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import _ from 'lodash';
import can from 'can/util/util';
import Component from 'can/component/component';
import template from './player-header.stache';
import PlayerService from 'scripts/services/player-service';
import liveVideoService from 'scripts/services/live-video-service';
import deviceUtil from 'scripts/utils/device';

import { showLiveVideoModal } from 'components/live-video-modal/live-video-modal';

const playerPageUrl = window.globalSettings.pagePaths.player;

Component.extend({
    tag: 'player-header-recap',
    template: template,
    viewModel: {
        favorites: PlayerService.getFavorites(),
        define: {
            player: {
                Type: can.Map,
                value: null,
            },
            playerInfo: {
                Type: can.Map,
                value: null,
            },
            backgroundImage: {
                Type: can.Map,
                value: null,
            },
            playerPagePath: {
                get() {
                    let playerId = this.attr('player.identifier');
                    return can.sub(playerPageUrl, { playerId });
                },
            },
            isUserPlayedAnyHole: {
                get() {
                    let result = false;

                    _.forEach(
                        _.get(
                            this.attr('playerInfo'),
                            'roundsInfo.0.scorecard.holeResults',
                        ),
                        (hole) => {
                            if (_.get(hole, 'score.displayValue')) {
                                result = true;
                                return false;
                            }
                        },
                    );

                    return result;
                },
            },
            liveVideoUrl: {
                type: 'string',
                get() {
                    return this.playerInfo.liveVideo
                        ? liveVideoService.getLiveUrl(
                              this.playerInfo.liveVideo.identifier,
                          )
                        : '#';
                },
            },
        },

        closeLiveVideoPlayer: function() {
            this.attr('livePlayerItem', null);
        },

        startPlayingRecap: function(event) {
            event.preventDefault();
            this.attr('startFullVideoRecap')();
        },

        onLiveVideoClick(event) {
            if (deviceUtil.isMobileWeb) {
                event.preventDefault();
                showLiveVideoModal();
            }
        },
    },
    events: {
        '.icon-favorite-star click'() {
            PlayerService.toggleFavorite(
                this.viewModel.attr('player.identifier'),
            );
            return false;
        },
    },
});
